import { Avatar, Button, useMantineTheme } from '@mantine/core'

import { useAccountMenuItems } from '@/layouts/AuthenticatedLayout/components/AccountMenu/AccountMenu.config'

import { useUserStore } from '@/store/user.store'

import { DropdownMenu } from '@/components/DropdownMenu/DropdownMenu'
import { Text } from '@/components/Text/Text'

export function AccountMenu() {
  const user = useUserStore.use.user()
  const theme = useMantineTheme()
  const items = useAccountMenuItems()

  const displayName = `${user?.firstName} ${user?.lastName}`

  const dropdownButton = (
    <Button bg="none" h={40} p={0}>
      <Avatar
        alt={displayName}
        color={theme.other.colors.darkGreen}
        mr={8}
        src={user?.avatar}
      />

      <Text>{displayName}</Text>
    </Button>
  )

  return <DropdownMenu button={dropdownButton} items={items} />
}
